<script>
/** @typedef {
* 'Vector' |
* 'align-center' |
* 'align-left' |
* 'align-right' |
* 'alt' |
* 'arrow-down' |
* 'arrow-down-tail' |
* 'arrow-left' |
* 'arrow-left-tail' |
* 'arrow-right' |
* 'arrow-up' |
* 'avatar' |
* 'body' |
* 'bold' |
* 'booking' |
* 'bookmark' |
* 'bookmarks' |
* 'box' |
* 'box-crossed-out' |
* 'building' |
* 'building-filled' |
* 'bullet' |
* 'button' |
* 'calendar' |
* 'calm-face' |
* 'canvas' |
* 'canvas-secondary' |
* 'card-stack' |
* 'carousel' |
* 'check' |
* 'check-inverted' |
* 'circle' |
* 'circle-with-bullet' |
* 'clear' |
* 'close' |
* 'color' |
* 'colored-text' |
* 'comment' |
* 'confetti' |
* 'crop' |
* 'csv' |
* 'cycle' |
* 'decimal' |
* 'description' |
* 'disc' |
* 'doc' |
* 'doc-secondary' |
* 'dot-dot-dot' |
* 'double-arrow-left' |
* 'double-check' |
* 'download' |
* 'drag-handle' |
* 'duplicate' |
* 'duplicate-plus' |
* 'email' |
* 'enter' |
* 'equal-height' |
* 'exit' |
* 'external-link' |
* 'eye' |
* 'eye-closed' |
* 'file' |
* 'filter' |
* 'filter-active' |
* 'four-columns' |
* 'gallery' |
* 'grid' |
* 'grid-2' |
* 'grid-secondary' |
* 'grid-tall' |
* 'hand-heart' |
* 'heading-1' |
* 'heading-2' |
* 'heading-3' |
* 'highlight' |
* 'horizontal-spacing-arrow' |
* 'image' |
* 'image-at-top' |
* 'image-list' |
* 'image-list-reversed' |
* 'instagram' |
* 'invoice' |
* 'italic' |
* 'lightning' |
* 'lightning-2' |
* 'link' |
* 'list' |
* 'list-decimal' |
* 'list-decimal-leading-zero' |
* 'list-icon' |
* 'list-image-decimal' |
* 'list-lower-latin' |
* 'list-lower-roman' |
* 'list-task' |
* 'list-upper-latin' |
* 'list-upper-roman' |
* 'lock' |
* 'lock-open' |
* 'menu' |
* 'messenger-illustration' |
* 'minus' |
* 'no-title' |
* 'page' |
* 'paperplane' |
* 'parcel' |
* 'pause' |
* 'pencil' |
* 'person-2' |
* 'phone' |
* 'pin' |
* 'play' |
* 'plus' |
* 'polaroid-stack' |
* 'radio-false' |
* 'radio-true' |
* 'rocket' |
* 'rotate-left' |
* 'search' |
* 'settings' |
* 'sign-up-personal' |
* 'sign-up-team' |
* 'signup-business' |
* 'small-arrow-down' |
* 'small-arrow-left' |
* 'small-arrow-up' |
* 'speaker-high' |
* 'speaker-mute' |
* 'speed' |
* 'square' |
* 'tag' |
* 'text-input' |
* 'three-columns' |
* 'title-1' |
* 'title-2' |
* 'title-3' |
* 'tooltip' |
* 'tooltip-circle-outline' |
* 'tooltip-outline' |
* 'trash' |
* 'two-columns' |
* 'unequal-height' |
* 'unpin' |
* 'vertical-spacing-arrow' |
* 'warning' |
* 'width-extended-1' |
* 'width-extended-2' |
* 'width-flex' |
* 'width-full' |
* 'width-inner' |
* 'yin-and-yang'
* } IconTypes
*/

  /**
   * INSTRUCTIONS:
   * svg symbols must have an id
   * svg symbols must have a viewbox property
   * svg symbols must NOT have width or height defined
   * svg paths should not have a fill attribute so they can inherit the currentColor
   * correct symbol tag:
   * <symbol viewBox="0 0 15 15" fill="none" id="my-icon-name">
   */

  let {
    /**
     * Specify an icon by name located in the default icon folder
     * @type { !IconTypes | string }
     **/
    name = 'bullet',
    ...rest
  } = $props();
</script>

<svg class='icon {rest.class}' role='presentation' {...rest}>
  <use href={`/assets/sprite-120.svg#${name}`}></use>
</svg>

<style lang='postcss'>
  :global(:root) {
    --icon-default-size: 17px;
  }
  svg, :global(.icon) {
    color: var(--icon-color1, var(--color-default-foreground-300));
    fill: currentColor;
    user-select: none;
    object-fit: contain;
    object-position: center;
    transition: fill 150ms ease, color 150ms ease;
    width: var(--icon-size, var(--icon-default-size));
    height: var(--icon-size, var(--icon-default-size));
    min-width: var(--icon-size, var(--icon-default-size));
    min-height: var(--icon-size, var(--icon-default-size));
    /* TODO: re-draw all icons on 17px grid with a 15px inner bounding box area and a 1.5px stroke */
    margin: var(--icon-outer-spacing, 0px);
  }
  :global(button) > .icon {
    min-width: var(--touchable-target-min-size);
  }
</style>